import React, {useState} from "react";
import {Input} from "@base-ui-components/react";


function useConstraint(con : string) : (value: number) => boolean {
    const tmp = con.split(';')

    function validate(value : number): boolean {
        return tmp.some((vx) => {
            const a = vx.split('-')
            const min = parseInt(a[0])
            const max = parseInt(a[1])
            if( value >= min && value <= max) {
                return true
            }
        })
    }

    return validate
}

type BitFieldProps = {
    value: number,
    onChange: (value: number) => void,
    validate: (value: number) => void,
}

const BitField = ({value, onChange, validate} : BitFieldProps) => {
    function setValue(bit :number) {
        onChange(value ^ (1 << bit))
    }

    let bits = []
    for(let i = 7; i >= 0; i--) {
        const dav = (value & ( 1 << i)) > 0
        bits.push(<Input key={i} type={'checkbox'} checked={dav} onChange={() => setValue(i)} />)
    }

    return (
        <div style={{
        }}>
            {bits}
        </div>
    )
}

const linestyle= {
    display:'flex',
    flexDirection:'row',
    justifyContent:'right',
    margin:'5px',
}

type ValidatingInputProps = {
    value: number;
    constraint: string;
    onChange: (val: number) => void;
    showBits: boolean;
}

export default function ValidatingInput({value, constraint, onChange, showBits = false}: ValidatingInputProps) {

    const [valid, setValid] = useState<number>(true);
    const [lv, setLv] = useState<number>(value);

    const validate = useConstraint(constraint)

    const setValue = (val: number) : void => {
        if( validate(val) ){

            setValid(true)
        } else {
            setValid(false)
        }

        onChange(val)

        setLv(val)
    }

    const select_style = {
        width: '50px',
        border: '1px solid #ccc',
        borderColor: valid?'#000000':'#c71919',
        color: valid?'#000000':'#c71919',
    }

    //const number = data?.number
    return (
        <div style={linestyle}>
            {!valid && <label onClick={(e) => {}}>{constraint}</label>}
            {showBits && <BitField value={value} onChange={(v) =>setValue(v)} validate={validate}/>}
            <input style={select_style} value={ value } onChange={(e) =>setValue(e.target.value)}/>
            <button disabled={!valid}>write</button>
        </div>
    )
}

